import generateTypes from '../../utils/generateTypes';

export const GET_BADGES = generateTypes('GET_BADGES');
export const RESET_BADGES = generateTypes('RESET_BADGES');
